import React from "react";
import Text from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";
import Card from "@/component/card";
import Button from "@/bit/components/components.button";
import Price from "@/bit/components/components.price";
import useDeviceKind from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";
import style from "./style";

const StreamingSlide = ({
  imgDesktop,
  imgMobile,
  title,
  seriesText,
  suscriptionText,
  aditionalPriceText,
  price,
  button,
  cardLink,
  taggingInfo,
}) => {
  const device = useDeviceKind();

  const img =
    device === "TABLET" || device === "MOBILE" ? imgMobile : imgDesktop;

  const miniProps = {
    "Image-1": {
      ...img,
      compressionByResize: false
    } 
  };


  return (
    <>
      <Card {...miniProps} className="card-cont">
        <div className="streaming-card">
          <div className="shadow"></div>
          <div className="card-content">
            {title && title.text && <Text {...title} cyData="StreamingPlatforms Card Title" />}
            {seriesText && seriesText.text && <Text {...seriesText} cyData="StreamingPlatforms Card Serie Text" />}
            <span className="separator" />
            <div className="price-container">
              {suscriptionText && suscriptionText.text && (
                <Text {...suscriptionText} cyData="StreamingPlatforms Card Suscription Text" />
              )}
              <div className="container-text-price">
                {aditionalPriceText && aditionalPriceText.text && (
                  <Text {...aditionalPriceText} cyData="StreamingPlatforms Card Text Price"  />
                )}
                {price && price.price && <Price {...price} cyData="StreamingPlatforms Card Price"  />}
              </div>
            </div>
            {button && (
              <Button
                taggingInfo={{
                  ...taggingInfo,
                  componentContent: button?.label,
                }}
                cyData="StreamingPlatforms Card Button" 
                {...button}
              />
            )}
          </div>
        </div>
        {cardLink && (
          <CustomLink
            taggingInfo={{
              ...taggingInfo,
              componentContent: suscriptionText?.text,
            }}
            cyData="StreamingPlatforms Card CustomLink" 
            {...cardLink}
          />
        )}
      </Card>
      <style jsx>{style}</style>
    </>
  );
};

export default StreamingSlide;

StreamingSlide.propTypes = {};
StreamingSlide.defaultProps = {};
